import { Component, createContext } from "react";

import { noop } from "@bokio/shared/utils";

import type { ValidationState } from "./Validation";
import type { PropsWithChildren } from "react";

export interface FormContextValue {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onFieldChange: (name: string, value: any, validation: any) => void;
	getFieldValue: (name: string) => void;
	disableAllFields: boolean;
}

export const FormContext = createContext<FormContextValue>({
	onFieldChange: noop,
	getFieldValue: noop,
	disableAllFields: false,
});

export interface FormValidationState {
	hasError: boolean;
	hasWarning: boolean;
}

interface FormProps {
	onSubmit?: () => void;
	onValidation?: (v: FormValidationState) => void;
	allowInvalidSubmit?: boolean;
	disableAll?: boolean;
	className?: string;
}

interface FormState {
	(key: string): ValidationState;
}

export class Form extends Component<PropsWithChildren<FormProps>, FormState> {
	constructor(props: FormProps) {
		super(props);

		this.state = {};
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.getValue = this.getValue.bind(this);
		this.checkValidation = this.checkValidation.bind(this);
	}

	getValue(name: string) {
		// @ts-expect-error -- 2025-07-13 PontusH: noImplicitAny config rule has been enabled. Please fix this error if you are editing this file.
		if (this.state[name]) {
			// @ts-expect-error -- 2025-07-13 PontusH: noImplicitAny config rule has been enabled. Please fix this error if you are editing this file.
			return this.state[name].value;
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onChange(name: string, value: any, validation: any) {
		this.setState(
			{
				[name]: {
					value,
					validation,
				},
			},
			this.checkValidation,
		);
	}

	checkValidation() {
		if (this.props.onValidation) {
			this.props.onValidation({
				hasWarning: this.hasWarning(),
				hasError: this.hasError(),
			});
		}
	}

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onSubmit(e: any) {
		e.preventDefault();

		if (!this.props.allowInvalidSubmit && this.hasError()) {
			return;
		}

		this.props.onSubmit && this.props.onSubmit();
	}

	hasWarning(): boolean {
		for (const i in this.state) {
			// @ts-expect-error -- 2025-07-13 PontusH: noImplicitAny config rule has been enabled. Please fix this error if you are editing this file.
			if (this.state[i].validation.hasWarning) {
				return true;
			}
		}

		return false;
	}

	hasError(): boolean {
		for (const i in this.state) {
			// @ts-expect-error -- 2025-07-13 PontusH: noImplicitAny config rule has been enabled. Please fix this error if you are editing this file.
			if (this.state[i].validation.hasError) {
				return true;
			}
		}

		return false;
	}

	render() {
		const value: FormContextValue = {
			onFieldChange: this.onChange,
			getFieldValue: this.getValue,
			disableAllFields: this.props.disableAll || false,
		};
		return (
			<FormContext value={value}>
				<form onSubmit={this.onSubmit} className={this.props.className}>
					{this.props.children}
				</form>
			</FormContext>
		);
	}
}
